import { Skeleton } from "@particles/index"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewClient.module.scss"
import { JobPreviewClientProps } from "./JobPreviewClient.types"

export default function JobPreviewClient(props: JobPreviewClientProps) {
    const { client } = props

    const { isLoading } = useJobPreviewCard()

    if (isLoading && !client) {
        return <Skeleton width={100} height={16} />
    }

    return <div className={styles.base}>{client}</div>
}
